import { PublicClientApplication, EventType, type AccountInfo } from '@azure/msal-browser'
import { msalConfig } from './msalConfig'

declare global {
  interface Window {
    __MSAL_INSTANCE__?: PublicClientApplication
    __MSAL_CALLBACK_ADDED__?: boolean
    __MSAL_REDIRECT_HANDLED__?: boolean
  __MSAL_INITIALIZE_PROMISE__?: Promise<void>
  }
}

function setFirstAccountActive(instance: PublicClientApplication) {
  const accounts = instance.getAllAccounts()
  if (accounts.length > 0 && !instance.getActiveAccount()) {
    instance.setActiveAccount(accounts[0] as AccountInfo)
  }
}

const existing = typeof window !== 'undefined' ? window.__MSAL_INSTANCE__ : undefined
const instance = existing ?? new PublicClientApplication(msalConfig)
if (!existing && typeof window !== 'undefined') {
  window.__MSAL_INSTANCE__ = instance
}

// Ensure initialize() is called exactly once before any other API
if (typeof window !== 'undefined' && !window.__MSAL_INITIALIZE_PROMISE__) {
  window.__MSAL_INITIALIZE_PROMISE__ = instance.initialize?.() ?? Promise.resolve()
}

const msalInitialized: Promise<void> =
  (typeof window !== 'undefined' && window.__MSAL_INITIALIZE_PROMISE__) || Promise.resolve()

// Only handle redirect after initialization
if (typeof window !== 'undefined' && !window.__MSAL_REDIRECT_HANDLED__) {
  window.__MSAL_REDIRECT_HANDLED__ = true
  msalInitialized
    .then(() => instance.handleRedirectPromise())
    .then(response => {
      if (response?.account) {
        instance.setActiveAccount(response.account)
      } else {
        setFirstAccountActive(instance)
      }
    })
    .catch(err => console.error('[MSAL] handleRedirectPromise error', err))
}

if (typeof window !== 'undefined' && !window.__MSAL_CALLBACK_ADDED__) {
  window.__MSAL_CALLBACK_ADDED__ = true
  instance.addEventCallback(event => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const payload = event.payload as unknown as { account?: AccountInfo } | undefined
      if (payload?.account) {
        instance.setActiveAccount(payload.account)
      } else {
        setFirstAccountActive(instance)
      }
    }
  })
}

export const msalInstance = instance
export { msalInitialized }
